// extracted by mini-css-extract-plugin
export default {"container":"welcome_container__PbkSN","wrapper":"welcome_wrapper__Pwsb3","heroText":"welcome_heroText__Jq9JM","heroBg":"welcome_heroBg__qU6PV"};